module.exports = __webpack_public_path__ + "img/ics_o_eye.0dc0af99.svg";